import { apiSaveStep, API_STEPS } from "../api/apiSaveStep";
import { PERSONAL_DATA_FORM_FIELDS_NAMES } from "./personalDataForm";
import { ERROR_TEXTS, VALIDATORS_TYPE } from "../utils/constants";
import { checkCoverageOffer } from "../utils/checkOfferCoverage";
import { apiGenerateOtp } from "../api/apiGenerateOtp";
import { apiGetProviders } from "../api/apiGetProviders";
import { fieldValidator } from "../utils/fieldValidator";
import { adfSendEvent } from "../tracking/adfSendEvent";
import toponimi from "../static/resources/toponimiGrouped.json";
import { getFullPlaceNameFromCode } from "../utils/getToponimoFromAddress";
import { apiCheckPodPdr } from "../api/checkPodPdr";
import { apiPdrPodGetInfo } from "../api/apiPdrPodCheckGetInfo";
import { pdrPodBlockPopupSetIsOpen, PDR_POD_BLOCK_CATEGORIES } from "./pdrPodBlockPopupTimeGate";

const FIELD_REQUIRED_MESSAGE = "Campo obbligatorio";

const DEFAULT_OPTIONAL_SUPPLY_FIELDS = {
    residenceAddress: 'indirizzoResidenza',
    residenceAddressPlaceNameText: 'toponimoIndirizzoResidenzaTesto',
    residenceAddressPlaceNameCode: 'toponimoIndirizzoResidenza',
    residenceAddressNumber: 'numeroIndirizzoResidenza',
    residenceAddressSuffix: 'suffissoIndirizzoResidenza',
    residenceMunicipality: 'comuneResidenza',
    residenceCap: 'capResidenza',
    residenceProvince: 'provinciaResidenza',

    residenceAddressError: 'indirizzoResidenzaError',
    residenceAddressPlaceNameTextError: 'residenceAddressPlaceNameTextError',
    residenceAddressPlaceNameCodeError: 'residenceAddressPlaceNameCodeError',
    residenceAddressNumberError: 'numeroIndirizzoResidenzaError',
    residenceMunicipalityError: 'comuneResidenzaError',
    residenceCapError: 'capResidenzaError',
    residenceProvinceError: 'provinciaResidenzaError',
}

const DEFAULT_OPTIONAL_RECAPITO_FIELDS = {
    recapitoPlaceNameCode: 'toponimoIndirizzoRecapito',
    recapitoPlaceNameText: 'toponimoIndirizzoRecapitoText',
    recapitoAddress: 'indirizzoRecapito',
    recapitoAddressNumber: 'numeroIndirizzoRecapito',
    recapitoSuffix: 'suffissoIndirizzoRecapito',
    recapitoMunicipality: 'comuneRecapito',
    recapitoCap: 'capRecapito',
    recapitoProvince: 'provinciaRecapito',

    recapitoPlaceNameCodeError: 'toponimoIndirizzoRecapitoError',
    recapitoPlaceNameTextError: 'toponimoIndirizzoRecapitoTextError',
    recapitoAddressError: 'indirizzoRecapitoError',
    recapitoAddressNumberError: 'numeroIndirizzoRecapitoError',
    recapitoSuffixError: 'suffissoIndirizzoRecapitoError',
    recapitoMunicipalityError: 'comuneRecapitoError',
    recapitoCapError: 'capRecapitoError',
    recapitoProvinceError: 'provinciaRecapitoError',
}

const DEFAULT_OPTIONAL_GAS_FIELDS = {
    gasSupplyAddress: 'indirizzoFornituraGas',
    gasSupplyAddressNumber: 'numeroIndirizzoFornituraGas',
    gasSupplyMunicipality: 'comuneFornituraGas',
    gasSupplyCap: 'capFornituraGas',
    gasSupplyProvince: 'provinciaFornituraGas',
    gasSupplyAddressError: 'indirizzoResidFornituraGas',
    gasSupplyAddressNumberError: 'numeroIndirizzoResidFornituraGas',
    gasSupplyMunicipalityError: 'comuneResidFornituraGas',
    gasSupplyCapError: 'capResidFornituraGas',
    gasSupplyProvinceError: 'provinciaResidFornituraGas',
}

export const SUPPLY_ADDRESS_FORM_FIELD_NAMES = {
    address: 'indirizzo',
    addressPlaceNameOptions: 'addressPlaceNameOptions',
    addressPlaceNameText: 'toponimoIndirizzoText',
    addressPlaceNameCode: 'toponimoIndirizzo',
    addressSuffix: 'suffissoIndirizzo',
    addressNumber: 'numeroCivico',
    municipality: 'comune',
    cap: 'cap',
    province: 'provincia',
    addressError: 'addressError',
    addressPlaceNameTextError: 'addressPlaceNameTextError',
    addressPlaceNameCodeError: 'addressPlaceNameCodeError',
    addressNumberError: 'addressNumberError',
    municipalityError: 'municipalityError',
    capError: 'capError',
    provinceError: 'provinceError',
    supplyAddressMatchesResidence: 'fornituraLuceCoincide',

    // Optional residence fields if it doesn't match the supply one
    ...DEFAULT_OPTIONAL_SUPPLY_FIELDS,

    recapitoAddressMatchesSupply: 'indirizzoRecapitoCoincideConFornitura',
    ...DEFAULT_OPTIONAL_RECAPITO_FIELDS,

    currentEnergySupplierError: 'currentEnergySupplierError',
    pod: 'pod',
    podError: 'podError',
    energyConsumption: 'consumoLuce',
    energyConsumptionError: 'energyConsumptionError',
    currentPower: 'potenza',
    currentPowerError: 'currentPowerError',

    currentGasSupplierError: 'currentGasSupplierError',
    pdr: 'pdr',
    pdrError: 'pdrError',
    currentGasConsumption: 'consumoGas',
    currentGasConsumptionError: 'currentGasConsumptionError',
    supplyAddressGasMatchesEnergy: 'fornituraGasCoincide',
    gasUsageType: 'tipologiaUsoGas',
    gasUsageTypeComplete: 'tipologiaUsoGasCompleta',

    // Optional gas supplier if it doesn't match the energy one
    ...DEFAULT_OPTIONAL_GAS_FIELDS,

    gasUsageTypeCooking: "usoGasCucina",
    gasUsageTypeHotWater: "usoGasAcquaCalda",
    gasUsageTypeHeat: "usoGasRiscaldamento",

    energySuppliersListGlobal: 'energySuppliersListGlobal',
    energySuppliersList: "listaFornitoriEnergia",
    currentEnergySupplier: 'attualeFornitoreLuce',
    energyOptionSelectedCode: 'energyOptionSelectedCode',

    gasSuppliersListGlobal: 'gasSuppliersListGlobal',
    gasSuppliersList: "listaFornitoriGas",
    currentGasSupplier: 'attualeFornitoreGas',
    gasOptionSelectedCode: 'gasOptionSelectedCode',

    timeStart: 'timeStart',
    timeSpent: 'tempoImpiegato',

    isSubmittingForm: 'isSubmittingForm',
    errorFormSubmission: 'errorFormSubmission',
    successText: 'successText'
}

const REQUIRED_RECAPITO_FIELDS = [
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumber,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode,
]

const REQUIRED_FIELDS = [
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.address,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.province,

    SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince,

    ...REQUIRED_RECAPITO_FIELDS,
];

const REQUIRED_FIELDS_ENERGY = [
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumption,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPower,
]

const REQUIRED_FIELDS_GAS = [
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumption,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddress,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince,
];

const defaultErrorState = {
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameTextError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCodeError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumberError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipalityError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.capError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.provinceError]: '',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplierError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.podError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumptionError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPowerError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplierError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdrError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumptionError]: '',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameTextError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameTextError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumberError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipalityError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCapError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvinceError]: '',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCodeError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameTextError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumberError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoSuffixError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipalityError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCapError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvinceError]: '',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumberError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipalityError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCapError]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvinceError]: '',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission]: '',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.successText]: ''
}

const MAP_FIELD_ERROR = {
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCodeError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.address]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameTextError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumberError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipalityError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.capError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.province]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.provinceError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplierError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.podError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumption]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumptionError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPower]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPowerError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplierError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdrError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumption]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumptionError,

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameTextError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCodeError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumberError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipalityError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCapError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvinceError,

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddress]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumberError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipalityError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCapError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvinceError,

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCodeError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameTextError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumber]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumberError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipalityError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCapError,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince]: SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvinceError,
}

const initialState = {
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.address]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressSuffix]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.province]: '',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressMatchesResidence]: true,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumption]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPower]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumption]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressGasMatchesEnergy]: true,

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressSuffix]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince]: '',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressMatchesSupply]: true,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumber]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoSuffix]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince]: '',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddress]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince]: '',
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageType]: 'C1',

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeCooking]: false,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHotWater]: false,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHeat]: false,

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.energySuppliersListGlobal]: [],
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.energySuppliersList]: [],
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyOptionSelectedCode]: null,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSuppliersListGlobal]: [],
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSuppliersList]: [],
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasOptionSelectedCode]: null,

    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.timeStart]: null,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.timeSpent]: 0,
    [SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm]: false,
    ...defaultErrorState
};

const SUPPLY_ADDRESS_FORM_SET_PROVIDERS = 'SUPPLY_ADDRESS_FORM_SET_PROVIDERS';
const supplyAddressFormSetProviders = (providers) => ({ type: SUPPLY_ADDRESS_FORM_SET_PROVIDERS, energy: providers.luce, gas: providers.gas });

export const supplyAddressFormGetProviders = () => {
    return async dispatch => {
        try {
            const providers = await apiGetProviders();
            return dispatch(supplyAddressFormSetProviders(providers));
        } catch (error) {

        }
    }
}

const SUPPLY_ADDRESS_CHANGE_TEXT_FIELD = 'SUPPLY_ADDRESS_CHANGE_TEXT_FIELD';
export function supplyAddressChangeTextField(name, value) {
    return {
        type: SUPPLY_ADDRESS_CHANGE_TEXT_FIELD,
        name,
        value
    }
}

const SUPPLY_ADDRESS_SET_ERROR_TEXT = 'PERSONAL_DATE_SET_ERROR_TEXT';
function supplyAddressSetErrorText(name, value) {
    return {
        type: SUPPLY_ADDRESS_SET_ERROR_TEXT,
        name,
        value
    }
}

const SUPPLY_ADDRESS_RESET_ERROR = 'SUPPLY_ADDRESS_RESET_ERROR';
export function supplyAddressResetError(name) {
    return { type: SUPPLY_ADDRESS_RESET_ERROR, name }
}

const SUPPLY_ADDRESS_FILTER_ENERGY_LIST = 'SUPPLY_ADDRESS_FILTER_ENERGY_LIST';
function supplyAddressSetEnergyList(list) {
    return { type: SUPPLY_ADDRESS_FILTER_ENERGY_LIST, list }
}

const SUPPLY_ADDRESS_FILTER_GAS_LIST = 'SUPPLY_ADDRESS_FILTER_GAS_LIST';
function supplyAddressSetGasList(list) {
    return { type: SUPPLY_ADDRESS_FILTER_GAS_LIST, list }
}

let energyListUpdateTimeout = null;
export function supplyAddressFilterEnergyList(value) {
    return (dispatch, getState) => {
        const state = getState();
        const energySuppliers = state.supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energySuppliersListGlobal];
        value = value.toUpperCase();
        clearTimeout(energyListUpdateTimeout);
        energyListUpdateTimeout = setTimeout(() => {
            console.log('Timeout energy suppliers triggered');
            dispatch(supplyAddressSetEnergyList(energySuppliers.filter(s => s.DESCRIZIONE.indexOf(value) !== -1)));
        }, 500);
    }
}

let gasListUpdateTimeout = null;
export function supplyAddressFilterGasList(value) {
    return (dispatch, getState) => {
        const state = getState();
        const gasSuppliers = state.supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSuppliersListGlobal];
        value = value.toUpperCase();
        clearTimeout(gasListUpdateTimeout);
        gasListUpdateTimeout = setTimeout(() => {
            console.log('Timeout gas suppliers triggered');
            dispatch(supplyAddressSetGasList(gasSuppliers.filter(s => s.DESCRIZIONE.indexOf(value) !== -1)));
        }, 500);
    }
}

let addressPlaceNameTimeout = null;
export function addressPlaceNameFilter(value) {
    return dispatch => {
        clearTimeout(addressPlaceNameTimeout);
        addressPlaceNameTimeout = setTimeout(() => {
            if (!value || value.length === 0) {
                return dispatch(supplyAddressChangeTextField(
                    SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameOptions, toponimi['V']));
            }

            value = value.toUpperCase();
            const firstChar = value.charAt(0);
            const toponimiToSearchFrom = toponimi[firstChar];
            if (!toponimiToSearchFrom) {
                return dispatch(supplyAddressChangeTextField(
                    SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameOptions, []));
            }

            dispatch(supplyAddressChangeTextField(
                SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameOptions,
                toponimi[firstChar].filter(s => s.TOP_DESCRIZIONE_BREVE.indexOf(value) !== -1)
            ));
        }, 500);
    }
}

export function supplyAddressValidateSupplier(list, input, field = 'DESCRIZIONE') {
    return list.find(s => s[field] === input.toUpperCase());
}

const SUPPLY_ADDRESS_FORM_SET_FROM_MODEL = 'SUPPLY_ADDRESS_FORM_SET_FROM_MODEL'
export function supplyAddressSetterFromModel(state) {
    return { type: SUPPLY_ADDRESS_FORM_SET_FROM_MODEL, state };
}
export function supplyAddressSetFromModel(user) {
    return async (dispatch) => {
        const gasUsageTypeComplete = user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeComplete];
        console.log(user);
        let providers = []
        try {
            providers = await apiGetProviders();
            dispatch(supplyAddressFormSetProviders(providers));
        } catch (error) {
            console.log(error);
        }

        user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeCooking] = false;
        user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHotWater] = false;
        user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHeat] = false;
        // Set the usage type
        if (gasUsageTypeComplete) {
            if (gasUsageTypeComplete.indexOf('1') !== -1) user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeCooking] = true;
            if (gasUsageTypeComplete.indexOf('2') !== -1) user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHotWater] = true;
            if (gasUsageTypeComplete.indexOf('3') !== -1) user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHeat] = true;
        }

        // Set the current suppliers. On the online state the code is inside the currentEnergySupplier, while in local
        // state currentEnergySupplier holds the description
        const energySupplierCodeOnline = user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier];
        if (energySupplierCodeOnline) {
            const energySupplier = supplyAddressValidateSupplier(
                providers.luce,
                energySupplierCodeOnline,
                'CODICE_PLAYER'
            );
            if (!energySupplier) {
                console.log('Online energy supplier not found');
                user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier] = '';
            } else {
                console.log('Online energy supplier found', energySupplier);
                user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyOptionSelectedCode] = energySupplier.CODICE_PLAYER;
                user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier] = energySupplier.DESCRIZIONE;
            }
        }

        const gasSupplierCodeOnline = user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier];
        if (gasSupplierCodeOnline) {
            const gasSupplier = supplyAddressValidateSupplier(
                providers.gas,
                gasSupplierCodeOnline,
                'CODICE_PLAYER'
            );
            if (!gasSupplier) {
                console.log('Online gas supplier not found');
                user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier] = '';
            } else {
                console.log('Online gas supplier found', gasSupplier);
                user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasOptionSelectedCode] = gasSupplier.CODICE_PLAYER;
                user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier] = gasSupplier.DESCRIZIONE;
            }
        }

        // Get the place name for the address
        if (user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode]) {
            const placeName = getFullPlaceNameFromCode(user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode]);
            if (placeName) user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText] = placeName.TOP_DESCRIZIONE_BREVE;
        }

        // Get the place name for the address residence
        if (user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode]) {
            const placeName = getFullPlaceNameFromCode(user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode]);
            if (placeName) user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText] = placeName.TOP_DESCRIZIONE_BREVE;
        }

        // Get the place name for the recapito
        if (user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode]) {
            const placeName = getFullPlaceNameFromCode(user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode]);
            if (placeName) user.secondStep[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText] = placeName.TOP_DESCRIZIONE_BREVE;
        }

        return dispatch(supplyAddressSetterFromModel({ ...user.secondStep }));
    }
}

export function supplyAddressFormValidateAndSubmit(finished = true) {
    return async (dispatch, getState) => {
        const { supplyAddressForm, personalDataForm, offer, globalFormFieldsReducer } = getState();
        const form = { ...supplyAddressForm };
        const otp = globalFormFieldsReducer.otp;

        let error = false;

        const timeSpent = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.timeSpent]
            + parseInt(Date.now() / 1000, 10) - form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.timeStart];

        form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.timeSpent] = timeSpent;
        dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.timeSpent, timeSpent));
        dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.timeStart, parseInt(Date.now() / 1000, 10)));

        // Reset the error state
        dispatch(supplyAddressResetError());

        const email = personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.email];

        // Populate the optional fields if the supply address matches the residence
        if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressMatchesResidence]) {
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.address];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressSuffix] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressSuffix];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.province];
        }

        // Populate the optional fields if the recapito address matches the supply
        if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressMatchesSupply]) {
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.address];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumber] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoSuffix] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressSuffix];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.province];
        }

        // Populate the optional fields if the gas supply matches the energy supply
        if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressGasMatchesEnergy]) {
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddress] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.address];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap];
            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince] = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.province];
        }

        const gasUsageTypeCooking = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeCooking];
        const gasUsageTypeHotWater = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHotWater];
        const gasUsageTypeHeat = form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHeat];

        // Save the frontend usage type
        let gasUsageTypeComplete = 'C';
        if (gasUsageTypeCooking) gasUsageTypeComplete += '1';
        if (gasUsageTypeHotWater) gasUsageTypeComplete += '2';
        if (gasUsageTypeHeat) gasUsageTypeComplete += '3';

        form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeComplete] = gasUsageTypeComplete;

        // Save vivigas usage type
        let gasUsageType = '';
        if (gasUsageTypeCooking && gasUsageTypeHotWater && gasUsageTypeHeat) {
            gasUsageType = 'C3';
        } else if (gasUsageTypeHeat && gasUsageTypeHotWater) {
            gasUsageType = 'C3';
        } else if (gasUsageTypeHeat && gasUsageTypeCooking) {
            gasUsageType = 'C3';
        } else if (gasUsageTypeHotWater && gasUsageTypeCooking) {
            gasUsageType = 'C2';
        } else if (gasUsageTypeHeat) {
            gasUsageType = 'C2';
        } else {
            gasUsageType = 'C1';
        }

        form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageType] = gasUsageType;

        if (!finished) {
            supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, true);
            try {
                await apiSaveStep(API_STEPS.second, { ...form, finished: false, otp });
                await apiGenerateOtp(otp);
                return dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.successText, 'Dati salvati con successo'));
            } catch (error) {
                dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, 'Errore nel salvare i dati.'));
                throw "Error saving data";
            } finally {
                supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false);
            }
        }

        let requiredFields = REQUIRED_FIELDS;
        if (offer.energy.length > 0 && offer.gas.length > 0) {
            requiredFields = [...requiredFields, ...REQUIRED_FIELDS_GAS, ...REQUIRED_FIELDS_ENERGY];
        } else if (offer.gas.length > 0) {
            requiredFields = [...requiredFields, ...REQUIRED_FIELDS_GAS];
        } else {
            requiredFields = [...requiredFields, ...REQUIRED_FIELDS_ENERGY];
        }

        // Check if all fields are populated
        for (let field of requiredFields) {
            if (!form[field] || form[field].length < 0) {
                dispatch(supplyAddressSetErrorText(MAP_FIELD_ERROR[field], FIELD_REQUIRED_MESSAGE));
                error = true;
            }
        }
        if (error) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, 'È necessario compilare tutti i campi.'));
            throw "Missing fields";
        }

        // Check if the pod/pdr are valid
        if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod] && !fieldValidator(form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod], VALIDATORS_TYPE.pod)) {
            console.log('Checking pod validator')
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.podInvalid));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.podError, ERROR_TEXTS.podInvalid));
            throw 'POD invalid';
        }

        if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr] && !fieldValidator(form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr], VALIDATORS_TYPE.pdr)) {
            console.log('Checking pdr validator');
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.pdrInvalid));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdrError, ERROR_TEXTS.pdrInvalid));
            throw 'PDR invalid';
        }

        // Check if the provinces are valid
        if (!fieldValidator(form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.province], VALIDATORS_TYPE.isProvinceValid)) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.provinceWrongFormat));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.provinceError, ERROR_TEXTS.validationError));
            throw 'Province invalid';
        }
        if (!fieldValidator(form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince], VALIDATORS_TYPE.isProvinceValid)) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.provinceWrongFormat));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvinceError, ERROR_TEXTS.validationError));
            throw 'Province invalid';
        }
        if (!fieldValidator(form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince], VALIDATORS_TYPE.isProvinceValid)) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.provinceWrongFormat));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvinceError, ERROR_TEXTS.validationError));
            throw 'Province invalid';
        }

        // Check if the suppliers are valid
        if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier]) {
            const energySupplier = supplyAddressValidateSupplier(
                form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energySuppliersListGlobal],
                form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier]
            );

            if (!energySupplier) {
                dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, 'Fornitore energia non valido'));
                dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplierError, 'Fornitore energia non valido'));
                throw 'Energy supplier not valid';
            }

            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyOptionSelectedCode] = energySupplier.CODICE_PLAYER;
        }

        if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier]) {
            const gasSupplier = supplyAddressValidateSupplier(
                form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSuppliersListGlobal],
                form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier]
            );

            if (!gasSupplier) {
                dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, 'Fornitore gas non valido'));
                dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplierError, 'Fornitore gas non valido'));
                throw 'Gas supplier not valid';
            }

            form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasOptionSelectedCode] = gasSupplier.CODICE_PLAYER;
        }

        // Set is submitting to true when we start the requests
        dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, true));

        try {
            await checkCoverageOffer(
                offer,
                form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality],
                form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality]
            );
        } catch (error) {
            adfSendEvent("vivigas|x|funnel|indirizzo-fornitura|no_copertura")();
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.areaNotCoveredByOffer));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false));
            throw 'Area not covered';
        }

        // Check POD and PDR
        let podResult, pdrResult;
        try {
            if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod]) {
                console.log('Api checking pod')
                podResult = await apiCheckPodPdr(form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod]);
            }
            if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr]) {
                console.log('Api checking pdr')
                pdrResult = await apiCheckPodPdr(form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr])
            }
        } catch (error) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, 'Errore nel verificare POD/PDR.'));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false));
            throw error;
        }

        if (podResult) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.podAlreadyClient));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false));
            throw "Pod already in use";
        }
        if (pdrResult) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.pdrAlreadyClient));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false));
            throw "Pdr already in use";
        }

        // Controlla che l'utente possa eseguire il cambio offerta energia
        let podTimeGateAvailable = true;
        if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod]) {
            try {
                console.log('Api checking pod TimeGate')
                const podTimeGate = await apiPdrPodGetInfo({ pod: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod] });
                if (!podTimeGate.isSwitchAvailable) {
                    podTimeGateAvailable = false;
                }
            } catch (error) {
                dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.podTimeGateServerError));
                dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false));
                throw error;
            }
        }
        if (!podTimeGateAvailable) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.podTimeGateError));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false));
            dispatch(pdrPodBlockPopupSetIsOpen(true, PDR_POD_BLOCK_CATEGORIES.POD));
            throw { error: 'PodTimeGateError ' }
        }

        // Controlla che l'utente possa eseguire il cambio offerta gas
        let pdrTimeGateAvailable = true;
        if (form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr]) {
            try {
                console.log('Api checking pdr TimeGate')
                const pdrTimeGate = await apiPdrPodGetInfo({ pdr: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr] });
                if (!pdrTimeGate.isSwitchAvailable) {
                    pdrTimeGateAvailable = false;
                }
            } catch (error) {
                dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.pdrTimeGateServerError));
                dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false));
                throw error;
            }
        }
        if (!pdrTimeGateAvailable) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.pdrTimeGateError));
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false));
            dispatch(pdrPodBlockPopupSetIsOpen(true, PDR_POD_BLOCK_CATEGORIES.PDR));
            throw { error: 'PdrTimeGateError ' }
        }

        try {
            await apiSaveStep(API_STEPS.second, { ...form, finished: true, otp });
        } catch (error) {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission, 'Errore nel salvare i dati.'));
            throw "Error saving data";
        } finally {
            dispatch(supplyAddressChangeTextField(SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm, false));
        }
    }
}

export function supplyAddressForm(state = initialState, action) {
    switch (action.type) {
        case SUPPLY_ADDRESS_CHANGE_TEXT_FIELD: {
            return { ...state, [action.name]: action.value, [MAP_FIELD_ERROR[action.name]]: '' };
        }
        case SUPPLY_ADDRESS_FORM_SET_FROM_MODEL: {
            return { ...state, ...action.state }
        }
        case SUPPLY_ADDRESS_FILTER_ENERGY_LIST: {
            return { ...state, [SUPPLY_ADDRESS_FORM_FIELD_NAMES.energySuppliersList]: action.list }
        }
        case SUPPLY_ADDRESS_FILTER_GAS_LIST: {
            return { ...state, [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSuppliersList]: action.list }
        }
        case SUPPLY_ADDRESS_FORM_SET_PROVIDERS: {
            return {
                ...state,
                [SUPPLY_ADDRESS_FORM_FIELD_NAMES.energySuppliersListGlobal]: action.energy,
                [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSuppliersListGlobal]: action.gas,
                [SUPPLY_ADDRESS_FORM_FIELD_NAMES.energySuppliersList]: action.energy,
                [SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSuppliersList]: action.gas,
            }
        }
        //errors
        case SUPPLY_ADDRESS_SET_ERROR_TEXT: {
            return { ...state, [action.name]: action.value }
        }
        case SUPPLY_ADDRESS_RESET_ERROR: {
            if (!action.name) {
                return { ...state, ...defaultErrorState }
            } else {
                return { ...state, [action.name]: '' }
            }
        }
        default: {
            return state;
        }
    }
}